<template>
<b-container class="bv-example-row">
  <b-row class="text-center " >
    <b-col lg="8" offset-lg="2">
        <div class="border rounded py-4 px-5">
            <h3 class="font-weight-bold">Sign in</h3>
            <div v-if="loginError" class="alert alert-danger" role="alert" :class="{'shake animated': animated}">
              Invalid E-mail or password
            </div>
             <b-form @submit.prevent="Submitlogin()" class="text-left" >
                <b-form-group id="input-group-email" label="E-mail"  label-for="input-email">
                    <b-form-input
                        id="input-email"
                        type="email"
                        required
                        v-model="login.email"
                        placeholder="example@gmail.com"
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Password" label-for="input-password">
                    <b-form-input
                        id="input-password"
                        type="password"
                        required
                         v-model="login.password"
                        placeholder="Password"
                    ></b-form-input>
                </b-form-group>
                <div class="d-md-flex justify-content-md-between mb-4">
                    <b-form-checkbox >Remember me</b-form-checkbox>
                    <router-link to="/forgot-password" class="orang-color cr-pointer" >Forgot password?</router-link>
                </div>
                <b-button 
                    block 
                    pill 
                    type="submit"
                    variant="outline-primary" 
                    class="btn-sigin bg-company my-2  not-shadow-active">
                    SIGN IN</b-button>
            </b-form>
            <div class="my-1 d-flex flex-row">
                <hr class="w-50 bd-gray">
                <span class="mx-3">or</span>
                <hr class="w-50 bd-gray">
            </div>
            <b-row>
                <b-col md="6" class="my-2">
                    <b-button 
                    block 
                    pill 
                    variant="outline-primary" 
                    @click="Submitloginmentor()"
                    class="btn-sigin bg-reply  not-shadow-active">
                    SIGN IN WITH GreatGrowth</b-button>
                </b-col>
                <b-col md="6" class="my-2 ">
                    <b-button 
                        block 
                        pill 
                        @click="gopath('/signin-integreat')"
                        variant="outline-primary" 
                        class="btn-sigin bg-integreat not-shadow-active align-middle d-md-flex justify-content-md-center align-items-md-center">
                        SIGN IN WITH 
                        <b-img  :src="require('@/assets/img/integreatLogo.png')" fluid alt="Responsive image"></b-img>
                    </b-button> 
                </b-col>
            </b-row>
            <p class="text-sigup "><span>Don’t have account?</span><span @click="$router.push('/signup')" class="pl-1 orang-color cr-pointer">Sign up here!</span></p>
        </div>
    </b-col>
  </b-row>
</b-container>
</template>
<script>
import {HTTPTICKET,HTTPMentor} from "@/axios.js";
import axios from "axios";
import Swal from 'sweetalert2'

export default {
  name: 'Signin',
  data () {
    return {
      loginError:false,
      loading:false,
      login:{
          email:'',
          password:'',
      },
      mentor:{
          email:'',
          password:'',
      },
      signinmentor:false,
      animated:false
    }
  },
  computed:{
    user(){
      return this.$store.state.user
    }
  },
  watch:{
    user(){
      if(this.user != ''){

      }
    }
  },
  methods:{
      openmodal(){
          this.signinmentor = true
          this.mentor = {}
      },
      errorcatch(){
        Swal.fire(
          'Error',
          'Please check your network connection',
          'error'
        )
      },
      Submitloginmentor(){
        this.$router.push('/signin-mentor')
        //window.open('http://localhost:8080/signin-mentor','mentor','height=400,width=600');
      },
      gopath(val){
            this.$router.push(val);
      },
      Submitlogin(){
        let data = {
            email:this.login.email,
            password:this.login.password
        }
        this.loading = true
        console.log('/api/sign/in',data)
        HTTPTICKET.post(`/api/sign/in`,this.login).then(res => {
         console.log('/api/sign/in',res.data)
                if (res.data.success) {
                this.loading = false
                let result = {...res.data.obj,loginalready:1}  
                   this.$store.commit('setUser',res.data.obj)

                   let token ={
                    key:'token',
                    value:res.data.tokenAuth
                   }
                   this.$store.commit('updateUser',token)
                   let type ={
                    key:'typeSystem',
                    value:'ticket'
                   }
                   this.$store.commit('updateUser',type)
                   this.$router.push("/");
           
                }else{
                    this.animated = true
                    setTimeout(() => {
                    this.animated = false
                    },1000)
                    this.loginError = true
                    setTimeout(()=>{
                      this.loginError = false
                    },5000)
                }
             
            })
            .catch(e => {  
                this.loading = false
                console.log("login/ticket",e);
                this.errorcatch()
        });
      }
  },
  components:{
  },
  mounted(){
    //   this.checktokenticket()
    // console.log()
  },
}

</script>
<style lang="scss" scoped>
$border : #DADADA;
/* sign in FORM */
    .text-sigup{
        padding-top: 6rem;
    }
    .btn-sigin{
        opacity: 0.6;
        min-height: 45px;
    }
    .btn-sigin:hover{
        opacity: 1;
    }
 #logreg-forms{
    width:412px;
    margin:10vh auto;
    background-color:#f3f3f3;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}
.modal-body #logreg-forms{
    width: 100%;
    margin: auto;
}
.modal-body{
    padding: 0;
}
#logreg-forms form {
    width: 100%;
    max-width: 410px;
    padding: 15px;
    margin: auto;
}
#logreg-forms .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
}
#logreg-forms .form-control:focus { z-index: 2; }
#logreg-forms .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
#logreg-forms .form-signin input[type="password"] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

#logreg-forms .social-login{
    width:390px;
    margin:0 auto;
    margin-bottom: 14px;
}
#logreg-forms .social-btn{
    font-weight: 100;
    color:white;
    width:190px;
    font-size: 0.9rem;
}

#logreg-forms a{
    display: block;
    padding-top:10px;
    color:lightseagreen;
}

#logreg-form .lines{
    width:200px;
    border:1px solid red;
}


#logreg-forms button[type="submit"]{ margin-top:10px; }

#logreg-forms .facebook-btn{  background-color:#3C589C; }

#logreg-forms .google-btn{ background-color: #DF4B3B; }

#logreg-forms .form-reset, #logreg-forms .form-signup{ display: none; }

#logreg-forms .form-signup .social-btn{ width:210px; }

#logreg-forms .form-signup input { margin-bottom: 2px;}

.form-signup .social-login{
    width:210px !important;
    margin: 0 auto;
}

#logreg-forms .social-btn{
width: 100%
}

/* Mobile */

 @media screen and (max-width:500px){
    #logreg-forms{
        width:300px;
    }
    
    #logreg-forms  .social-login{
        width:200px;
        margin:0 auto;
        margin-bottom: 10px;
    }
    #logreg-forms  .social-btn{
        font-size: 1.3rem;
        font-weight: 100;
        color:white;
        width:200px;
        height: 56px;
        
    }
    #logreg-forms .social-btn:nth-child(1){
        margin-bottom: 5px;
    }
    #logreg-forms .social-btn span{
        display: none;
    }
    #logreg-forms  .facebook-btn:after{
        content:'Facebook';
    }
  
    #logreg-forms  .google-btn:after{
        content:'Google+';
    }
    
}  
</style>



// WEBPACK FOOTER //
// src/components/Signin.vue